<template>
  <div>
    <div>
      <span :class="caretClass()" @click="toggle()" />
      <span class="mediumTitle"> <slot name="title" /> </span>
    </div>
    <div v-show="isExpanded" style="margin: 15px">
      <div v-if="thumbnailsAvailable">
        <b-row>
          <b-col
             v-for="(record, index) of records"
            :key="index"
            cols="3"
          >
            <image-thumbnail :record="record" @reload="$emit('reload')"/>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <div
            v-for="(record, index) of records"
            :key="index"
        >
          <div>
            <span
              ><b>{{ record.title }}</b>
              -
              <b>{{ record.account }}</b>
              -
              <b>({{ record.date }})</b>
            </span>
            <span>
              (<a
                style="color: blue; cursor: pointer"
                @click="downloadFile(record.id, record.name)">
                  {{record.name}}
              </a>)
            </span>
            <span v-if="getUserAccount.id == record.accountId">
              <b-button
                size="sm"
                variant="link"
                class="mr-1"
                @click="id=record.id; isDeleteModalOpen=true"
              >
                <img
                  src="../../../../assets/images/delete_icon.svg"
                  style="width: 20px; height: 20px"
                />
              </b-button>
          </span>
          </div>
        </div>
    </div>
    </div>
    <hr style="margin-top: 0px" />
    <delete-record-modal v-if="isDeleteModalOpen" :showModal.sync="isDeleteModalOpen" :id="id" @reload="$emit('reload')"/>

  </div>
</template>

<script>
import { axiosCall } from "../../../../utils/axiosCall";
import ImageThumbnail from "./ImageThumbnail.vue"
import axios from "axios";
import { mapGetters } from "vuex";
import DeleteRecordModal from "./DeleteRecordModal";

export default {
  name: "ExpandibleSection",
  components: {ImageThumbnail, DeleteRecordModal},
  props: {
    records: {
      type: Array,
      default: ()=>[],
    },
    thumbnailsAvailable:{
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(["getUserAccount"]),
  },
  data() {
    return {
        id: '',
        isExpanded: true,
        isDeleteModalOpen: false
    }
  },

  methods: {
    caretClass() {
      return this.isExpanded ? "bi-caret-down-fill" : "bi-caret-right-fill";
    },
    toggle() {
      this.isExpanded = !this.isExpanded;
    },

    downloadFile: async function (id, fileName) {
      
      await axiosCall({ url: "Records/downloadRecord/" + id + "/" + fileName, method: "GET"
      }).then((response) =>{
          const link = document.createElement("a");
          link.setAttribute("style", "display: none");
          link.href = response.data;
          link.download = fileName;
          link.target = "_blank";
          link.click();
          link.remove();
          });
    },

    getImageURL: async function(id, fileName){
      var src
      await axiosCall({ url: "Records/downloadRecord/" + id + "/" + filename, method: "GET"
      }).then((response) =>{
        src = JSON.stringify(response.data)
          });
      return src
    }
  },

}
</script>


